import * as React from "react";
import { AiChatAssistantRole } from "app/components/ai-chat-assistant/types";
import styles from "./chat-messages.scss";

export const ChatMessages = ({
  messages,
  running,
  endRef,
  translation,
  userMessageVariant = "default",
  className
}: {
  messages: any[];
  running: boolean;
  endRef: any;
  translation: Record<string, string>;
  userMessageVariant?: "default" | "lighter";
  className?: string;
}) => {

  const userMessageTextClass = [
    styles.userMsg,
    userMessageVariant === "lighter" ? styles.userMsgLighter : styles.userMsgDark
  ]
    .filter(Boolean)
    .join(" ");

  const containerClass = [
    styles.chatBody,
    className || ""
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={containerClass}>
      {messages.map((m, index) => {
        const content = (m.content ?? "").trim();
        const isAiChatAssistantRole = m.role === AiChatAssistantRole.Assistant;
        const isLatestMessage = index === messages.length - 1;
        const displayText =
          content ||
          (isAiChatAssistantRole && running && isLatestMessage
            ? translation.textThinking
            : "");

        if (!displayText) {
          return null;
        }

        return (
          <div
            className={`${styles.msgText} ${
              isAiChatAssistantRole ? styles.assistantMsg : userMessageTextClass
            }`}
            key={m.id}
          >
            {displayText}
          </div>
        );
      })}
      <div ref={endRef} />
    </div>
  );
};
